const normalSwitchSize = { containerSize: 'h-6 w-11 border-2', dotSize: 'h-5 w-5', dotPosition: 'translate-x-2.5' };

export const switchSizes = {
  lg: normalSwitchSize,
  md: normalSwitchSize,
  sm: { containerSize: 'h-5 w-9 border-1', dotSize: 'h-4 w-4', dotPosition: 'translate-x-2' },
};
